import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { FaRegTrashAlt } from "react-icons/fa";

import { trackResumoCompraEvent } from "utils/gtm";
import { CouponRulesModal } from "../../OrderResumePag/_components/CouponRulesModal";

const SectionLabel = styled.h3`
  font-size: 18px;
  font-weight: 400;
  color: var(--text-dark, #1D1D1F);
  margin: 0 0 12px;
`;

const InputRow = styled.div`
  display: flex;
  gap: 8px;
`;

const Input = styled.input`
  flex: 1;
  padding: 12px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 14px;
  color: var(--text-dark, #1D1D1F);
`;

const ApplyBtn = styled.button`
  padding: 12px 16px;
  background: #ffffff;
  border: 1px solid #707070;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #707070;
  text-transform: uppercase;
  cursor: pointer;
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const ErrorMsg = styled.div`
  color: #f89393;
  font-size: 12px;
  margin-top: 8px;
`;

const SuccessCard = styled.div`
  background: #f4fff3;
  border-radius: 4px;
  padding: 12px;
  margin-top: 12px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

const SuccessBody = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const SuccessTitle = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: #2d8d68;
`;

const SuccessText = styled.div`
  font-size: 12px;
  color: #4f4f4f;
`;

const RulesLink = styled.button`
  background: none;
  border: 0;
  text-decoration: underline;
  font-size: 12px;
  font-weight: 700;
  color: #4f4f4f;
  padding: 0;
  cursor: pointer;
  align-self: flex-start;
`;

const RemoveBtn = styled.button`
  background: none;
  border: 0;
  cursor: pointer;
  color: #707070;
`;

export default function CouponField({
  value,
  setValue,
  applied,
  info,
  error,
  loading,
  onApply,
  onRemove,
}) {
  const [rulesOpen, setRulesOpen] = useState(false);

  return (
    <div>
      <SectionLabel>Cupom/Gift Card</SectionLabel>
      <InputRow>
        <Input
          type="text"
          placeholder="Digitar código"
          value={applied ? info?.code || info?.name || "" : value}
          onChange={(e) => setValue(e.target.value)}
          disabled={applied || loading}
        />
        <ApplyBtn
          type="button"
          onClick={onApply}
          disabled={applied || loading || !value?.trim()}
        >
          APLICAR
        </ApplyBtn>
      </InputRow>

      {error && !applied && <ErrorMsg>{error}</ErrorMsg>}

      {applied && info && (
        <SuccessCard>
          <SuccessBody>
            <SuccessTitle>{info.code || info.name}</SuccessTitle>
            <SuccessText>
              Cupom{info?.category ? ` de ${info.category}` : ""} aplicado
            </SuccessText>
            {info?.rules && (
              <RulesLink
                type="button"
                onClick={() => {
                  trackResumoCompraEvent({ title: "ver-regra-cupom" });
                  setRulesOpen(true);
                }}
              >
                Ver regra de uso
              </RulesLink>
            )}
          </SuccessBody>
          <RemoveBtn
            type="button"
            aria-label="Remover cupom"
            onClick={() => {
              trackResumoCompraEvent({ title: "remover-cupom" });
              onRemove();
            }}
          >
            <FaRegTrashAlt />
          </RemoveBtn>
        </SuccessCard>
      )}

      {rulesOpen && (
        <CouponRulesModal
          open={rulesOpen}
          setOpen={setRulesOpen}
          couponRules={info?.rules || ""}
        />
      )}
    </div>
  );
}

CouponField.propTypes = {
  value: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired,
  applied: PropTypes.bool.isRequired,
  info: PropTypes.object,
  error: PropTypes.string,
  loading: PropTypes.bool,
  onApply: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};
